export type OtpVerificationErrorReason =
    // Verification could not be performed at all (e.g. capabilities check failed) —
    // the user never saw the verification modal
    | 'unavailable'
    // The user saw the verification modal but did not verify successfully
    | 'rejected';

export type OtpVerificationChannel = 'phone' | 'email';

export class OtpVerificationError extends Error {
    reason: OtpVerificationErrorReason;
    channel?: OtpVerificationChannel;

    constructor(
        message: string,
        reason: OtpVerificationErrorReason = 'rejected',
        channel?: OtpVerificationChannel,
    ) {
        super(message);
        this.name = 'OtpVerificationError';
        this.reason = reason;
        this.channel = channel;
    }
}
